/** Formatting values by unit ("%", "people", "km²"...). */
export function fmt(value, unit, short = false) {
  if (value === null || value === undefined || isNaN(value)) return '—';
  if (unit === '%') return (Math.round(value * 100) / 100).toString() + '%';
  if (unit === 'US$ bn') return '$' + (Math.round(value * 100) / 100).toString() + 'bn';
  if (unit === 'US$ m') return '$' + (Math.round(value * 10) / 10).toLocaleString('en-US') + 'm';
  if (unit === '₦ trn') return '₦' + (Math.round(value * 100) / 100).toString() + 'trn';
  if (unit === '₦ bn') return '₦' + (Math.round(value * 100) / 100).toLocaleString('en-US') + 'bn';
  if (unit === '₦') return '₦' + (Math.round(value * 100) / 100).toLocaleString('en-US');
  if (unit === 'million') return (Math.round(value * 100) / 100).toString() + 'm';
  if (unit === 'people') {
    if (short || value >= 1e6) return (value / 1e6).toFixed(value >= 1e7 ? 1 : 2).replace(/\.?0+$/, '') + 'M';
    return Math.round(value).toLocaleString('en-US');
  }
  const n = Math.round(value * 100) / 100;
  return n.toLocaleString('en-US') + (unit ? ' ' + unit : '');
}

/** "2026-08" -> "Aug 2026"; "2026-Q2" -> "Q2 2026"; "2026-09-22" -> "22 Sep 2026" (MPC meetings) */
export function periodLabel(p) {
  if (/^\d{4}-Q[1-4]$/.test(p || '')) return p.slice(5) + ' ' + p.slice(0, 4);
  if (/^\d{4}-\d{2}-\d{2}$/.test(p || '')) {
    const [y, mo, d] = p.split('-').map(Number);
    return new Date(Date.UTC(y, mo - 1, d)).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      timeZone: 'UTC'
    });
  }
  if (!/^\d{4}-\d{2}$/.test(p || '')) return p || '';
  const [y, m] = p.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, 1)).toLocaleDateString('en-GB', {
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
  });
}

/** Download rows as a CSV file. */
export function downloadCsv(filename, header, rows) {
  const esc = v => {
    const s = v === null || v === undefined ? '' : String(v);
    return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
  };
  const text = [header, ...rows].map(r => r.map(esc).join(',')).join('\n');
  const url = URL.createObjectURL(new Blob(['\ufeff' + text], {
    type: 'text/csv;charset=utf-8'
  }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}